import React, { useState } from "react";
import { StyleSheet, css } from "aphrodite";
import {Link} from "react-router-dom";

function Info(){
    //Logic
    const [isButtonHover, setIsButtonHover] = useState(false);

    //Css
    const styles = StyleSheet.create({
        containerStyle: {  
            display: "flex",
            flexDirection:'column',
            backgroundColor: "#011a39",
            justifyItems: "right",
            alignItems: "center",
            "@media (min-width: 1024px)": {
                justifyItems: "right",        
            }
            
        },
        secondTextStyle: {
            fontFamily: "Montserrat",
            display: "inline-block",
            textAlign: 'justify',
            wordWrap: "break-word",
            fontSize: "auto",
            padding:'10px',
            color: '#F0EFEC',
            "@media (min-width: 1024px)": {
                width: "50%",        
            }
            
        },
        dealerButtonStyle: {
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            display: "inline-block",
            cursor: "pointer",
            userSelect: "none",
            color: isButtonHover ? "#fec803":"#F0EFEC",
            backgroundColor: isButtonHover ? "#F0EFEC" : "#fec803",
            border: "none",
            padding:"0.52rem 4rem",
            margin: "1rem 0px 0.8rem",
            gridColumnStart: "1",
            gridColumnEnd: "4",
            gridRowStart: "3",
            borderRadius:'6px',
            transition:'0.3s'
        },
    
    //#region Fonts
        firstTextFontStyle: {
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "3rem",
            textAlign: "center",
            color:"#fec803"
        }
    })

    //#endregion
   
    //Display
    return(
        <>
            <div className={css(styles.containerStyle)}>
                <div className={css(styles.firstTextFontStyle)}>WHAT WE DO</div>
                <p className={css(styles.secondTextStyle)}>We specialize in designing and manufacturing high-performance trailers that meet the diverse needs of our customers across various industries. From utility trailers to custom-built solutions, we focus on delivering products that combine strength, durability, and functionality. Our team works closely with clients to understand their unique requirements, ensuring that each trailer is tailored to perform under the toughest conditions. Whether you’re in construction, agriculture, transportation, or any other sector, we provide reliable, long-lasting trailers that help businesses get the job done efficiently and safely. With a commitment to quality, innovation, and customer satisfaction, we’re here to support your success with every product we create.</p>
                <Link to="/about-us" className={css(styles.dealerButtonStyle)} 
                    onMouseEnter={() => setIsButtonHover(true)} 
                    onMouseLeave={() => setIsButtonHover(false)}>
                    MORE ABOUT US
                </Link>
            </div>
        </>
    );
}

export default Info